import { CardProps } from '@/components/molecules/card'
import CardGrid from './CardGrid'
import { ContactLinksMapper, mappedGridColumns } from '@/utils/mappingHelpers'
import { CardTypes, MediaTypes } from '@/types/enums'
import { generateImageData } from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'

function cardGridFactory(data: any, key: string | number): JSX.Element {
  const content = data?.content?.properties
  const mappedCards: CardProps[] = []

  content?.items?.map((item: any) => {
    const content = item.properties
    const cardType = mappedCardType(item.contentType)
    const headerImage =
      content?.header?.items[0]?.content?.properties?.mediaItem?.[0]
    const profileImage = content?.profilePicture?.[0]
    const ogImage = content?.openGraphImage?.[0]

    const mediaItemProps = generateImageData(
      {
        image: [headerImage ?? profileImage ?? ogImage],
      },
      GetUmbracoBaseUrl(),
    )

    if (mediaItemProps && mediaItemProps?.type !== MediaTypes.Image) {
      throw new Error('Something other than an image passed')
    }

    const publicationTitle = content?.title ?? item?.name
    const personTitle = content?.firstName + ' ' + content?.lastName
    const cardTitle =
      item.contentType === 'publicationDetailPage'
        ? publicationTitle
        : personTitle

    mappedCards.push({
      cardType: cardType,
      title: cardTitle,
      text: content?.text ?? content.jobtitle,
      date: content?.publicationDate ?? item?.createDate,
      tag: mappedTagForItem(item.contentType, content),
      link: {
        url: cardType !== CardTypes.Person ? item?.route?.path : '',
      },
      contactLinks: ContactLinksMapper(content?.socialMedia?.items),
      mediaData: mediaItemProps,
    })
  })

  return (
    <CardGrid
      key={`card-grid-${key}`}
      title={content?.title?.markup}
      items={mappedCards}
      gridColumns={mappedGridColumns(content.gridColumns)}
    />
  )
}

export function mappedCardType(type: string): CardTypes {
  switch (type) {
    case 'fundsMandatesDetailPage':
      return CardTypes.FundsAndMandates
    case 'contactPerson':
      return CardTypes.Person
    case 'publicationDetailPage':
      return CardTypes.Publication
    default:
      return CardTypes.Default
  }
}

export function mappedTagForItem(
  pageType: string,
  content: any,
): string {
  switch (pageType) {
    case 'publicationDetailPage':
      return content?.funds?.[0]?.name ?? ''
    case 'portfolioDetailPage':
      return content?.strategies?.[0]?.name ?? ''
    default:
      return ''
  }
}

export default cardGridFactory
